import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'

import SemanticUiModal from '../../components/modal';
import { LibraryControlComponent } from './control_library_components';
import { getText } from '../../helpers';

import 'semantic-ui-css/semantic.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../App.css';
import './index.css'

function ControlActions({hideLibControlDetails}) {
  return (
    <div>
      <Button size='medium' className="close-button" onClick={hideLibControlDetails}>
        {getText("Close")}
      </Button>
    </div>
  )
}

export default class LibraryControlDetails extends Component {
  render() {
    const modalOptions = { className: "library-control-details-modal", size: "tiny" }
    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={getText("Library Control Details")}
        content={<LibraryControlComponent {...this.props} />}
        actions={<ControlActions {...this.props} />}
        closeModal={this.props.hideLibControlDetails}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/control_library/library_control_details.js